export const maxImageSizeInMb = 10;
export const maxMediaSizeInMb = 500;
export const maxDocumentSizeInMb = 10;
export const documentAcceptedFileTypes =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
export const documentFileTypeString = "PDF, DOCX";
